<template>
<div class="inner-wrapper">
    <div class="content-main quat-detail-sec vendor-detail-block" v-if="vendorData && vendorData.vendor != null">
        <div class="page-title quote-title">
            <div class="float-left"><router-link :to="{name: 'viewVendors'}" class="btn custom-btn" style="font-size: 26px; line-height: 26px; padding: 4px 8px 1px;"><i  class="ri-arrow-left-s-line"></i></router-link>  </div>

            <div class="title-right float-right">
                <router-link :to="{name: 'editVendor', params: { id:vendorData.vendor.id}}" class="btn btn-info me-1"><i class="ri-edit-2-fill align-middle pe-1"></i> Edit</router-link>
                <input type="hidden" :value="vendorData.vendor.id" id="vendor_id">
                <button type="button" class="btn btn-primary me-1" @click="openHistory" id="open_history" data-toggle="modal">
                    <i class="ri-file-list-line align-middle pe-1"></i> History
                </button>
            </div>

        </div>
        <div class="mb-3">
            <div class="row">
                <div class="col-md-3">
                    <div class="card ">
                        <div class="card-body p-3">
                            <div  class="view-customer-hed">
                                <div class="view-customer-icon">
                                    <span><img :src="asset('admin/images/building-icon.png')" alt="building-icon" /></span>
                                </div>
                                <div class="rght-txt">
                                    <span class="active-txt">
                                        <span :class="[vendorData.vendor.status=='1' ?'lt-bl-bg':'lt-rd-bg']">
                                    {{vendorData.vendor.status=='1' ?'Active':'Inactive'}}
                                        </span>
                                    </span>
                                    <h5>{{vendorData.vendor.company_name}}</h5>
                                    <p>{{vendorData.vendor.address}}, {{vendorData.country_data.name}}</p>
                                </div>
                            </div>
                        </div>
                        <!--<div class="row left-blk">
                            <div class="col-md-12">
                                <label class="cmpny-text">{{vendorData.vendor.company_name}}</label>
                                <p class="address-txt">{{vendorData.vendor.address}}</p>
                                <p>{{vendorData.country_data.name}}</p>
                                <hr />
                                <i class="fa fa-link"></i>
                                <a v-if="vendorData.vendor.website!=''" :href="'http://' + vendorData.vendor.website" target="_blank">{{vendorData.vendor.website}}</a>
                                <a v-else href="javascript::void(0)">N/A</a>
                                <hr />
                                <img :src="asset('admin/images/phone-icon.png')" alt="phone-icon" />
                                <span v-if="vendorData.vendor.fax!=''">{{vendorData.vendor.fax}}</span>
                                <span v-else>N/A</span>

                            </div>
                        </div>-->
                    </div>

                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex align-items-center mb-2">
                                <div class="flex-grow-1">
                                    <h5 class="card-title mb-0">Contact & Link</h5>
                                </div>
                            </div>
                            <ul class="list-groupvend">
                                <!--<li class="cmpny-text"><i class="ri-building-line"></i>{{vendorData.vendor.company_name}}</li>
                                <li class="address-txt"><i class="ri-map-pin-line"></i> {{vendorData.vendor.address}}</li>
                                <li><i class="ri-road-map-line"></i> {{vendorData.country_data.name}}</li>-->
                                <li>
                                <i class="ri-links-line"></i>
                                <a v-if="vendorData.vendor.website!=''" :href="'http://' + vendorData.vendor.website" target="_blank">{{vendorData.vendor.website}}</a>
                                <a v-else href="javascript::void(0)">N/A</a>
                                </li>
                                <li>
                                <!--<img :src="asset('admin/images/phone-icon.png')" alt="phone-icon" />-->
                                <i class="ri-calculator-line"></i>
                                <span v-if="vendorData.vendor.fax != 'null' && vendorData.vendor.fax != '' ">{{vendorData.vendor.fax}}</span>
                                <span v-else>N/A</span>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex align-items-center mb-2">
                                <div class="flex-grow-1">
                                    <h5 class="card-title mb-0">Sample Address</h5>
                                </div>
                            </div>
                            <div style="white-space: pre-line;">
                                {{ vendorData.vendor.sample_address }}
                            </div>


                            
                            
                        </div>
                    </div>


                </div>
                <div class="col-md-9">
                    <div class="card  create-box-view mb-3">
                        <div class="card-header headnbtn">
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="card-title mb-0 flex-grow-1">Contact({{vendorData.vendor_contact.length}})</h5>
                            </div>
                        </div>
                        <div class="card-body p-3">
                            <div class="row">
                                <template v-if="vendorData.vendor_contact">
                                    <template v-for="contact in vendorData.vendor_contact">
                                        <div :class="[vendorData.vendor_contact.length == 1 ? 'col-md-4' : 'col-md-4']">
                                            <div class="vendor-blk-item">
                                                <div class="user-img">
                                                    <img :src="asset('admin/images/vendor_image.png')" alt="client" />
                                                </div>
                                                <div class="msg-block">
                                                    <div class="small-heading">{{contact['contact_name']}}</div>
                                                    <p><i class="ri-mail-open-line align-middle me-2"></i> {{contact['contact_email']}}</p>
                                                    <p><i class="ri-phone-line align-middle me-2"></i>
                                                        <span v-if="contact['mobile_numbers']">
                                                {{contact['mobile_numbers'].join(', ')}}</span>
                                                        <template v-else>
                                                            N/A
                                                        </template>
                                                    </p>
                                                    <p>
                                                        <i class="ri-calculator-line"></i>
                                                        <template v-if="contact['office_numbers']">
                                                            {{contact['office_numbers'].join(',')}}
                                                        </template>
                                                        <template v-else>
                                                            N/A
                                                        </template>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>

                    </div>


                    <div class="card  create-box-view mb-3">
                        <div class="card-header headnbtn">
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="card-title mb-0 flex-grow-1">Add Attachment :</h5>
                            </div>
                        </div>
                        <div class="card-body p-3">
                            <div class="white-bg add-attachment">
                                <div class="row">
                                    <div class="col-md-12 col-lg-6">
                                        <div class="add-attchmnt">
                                            <div class="pull-left"> </div>
                                            <div class="form-group files vendor_files color" id="uploadQuotefile">
                                                <!-- <label>Upload Your File </label> -->
                                                <input type="file" name='vendor_files[]' ref="myFiles" @change="previewFiles" class="form-control" id="vendor_files">
                                            </div>
                                        </div>
                                        <span ><img class="loader" style="display: none;width:50px;height:50px;" :src="asset('admin/images/loader.gif')"  /></span>

                                        <div id="add_vendor_files_attached"></div>
                                            <template v-if="vendorData.vendor_ats">
                                                <template v-for="vendor_at in vendorData.vendor_ats">
                                                    <div style="" class="pdf-dwn-sec num_">
                                                        <template v-if="vendor_at['image_type']=='2'">
                                                        <span class="far fa-file-pdf"></span>
                                                        </template>
                                                        <template v-if="vendor_at['image_type']=='3'">
                                                        <div><video width="320" height="240" controls>
                                                            <source :src="'/vendor_files/' + vendor_at['file_name']" type="video/mp4">
                                                            Your browser does not support the video tag.
                                                        </video></div>
                                                        </template>
                                                        <template v-else>

                                                        <input type="hidden" id="img_attach_id" :value="vendor_at['id']">
                                                        <!-- <a class="lightbox" :href="'#attach' + vendor_at['id']">
                                                            <img :src="'/vendor_files/'+vendor_at['file_name']" style="width: 40px;height: 32px;">
                                                        </a> -->
                                                        <div class="lightbox-target" :id="'attach' +vendor_at['id']">
                                                            <img :src="'/vendor_files/' + vendor_at['file_name']" style="padding:7px; width: 40px;height: 32px;">
                                                            <a class="lightbox-close" href="#"></a></div>
                                                        </template>
                                                        {{vendor_at['file_name']}}
                                                        <a href="javascript:void(0)" @click="deletFile(vendor_at.file_name, vendor_at.id)">
                                                            <i class="ri-delete-bin-6-line fa-pull-right"></i>
                                                        </a>
                                                        <!-- <a class="fa fa-trash-alt fa-pull-right" style="padding:7px; width: 40px;height: 32px;"
                                                        @click="deletFile(vendor_at.file_name, vendor_at.id)">
                                                        </a> -->
                                                        <a  @click.prevent="downloadItem({url:'/vendor_files/' + vendor_at.file_name,  label: vendor_at.file_name})" :href="'/vendor_files/' + vendor_at.file_name"  download>
                                                        <i class="fa fa-download fa-pull-right"></i>
                                                        </a>
                                                        <small class="light-clr">{{vendor_at['size']}}</small>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>

                        </div>

                    </div>


                    <div class="card  create-box-view mb-3">
                        <div class="card-header headnbtn">
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="card-title mb-0 flex-grow-1">Selling Products({{vendorData.vendor_bags.length}})</h5>
                            </div>
                        </div>
                        <div class="card-body p-3">
                            <div class="white-bg ">
                                <template v-if="vendorData.vendor_bags.length">
                                    <template v-for="bag in vendorData.vendor_bags">
                                        <div class="round-prod-item">
                                            <span class="fa fa-cube"></span> {{bag['bag_name']}}
                                        </div>
                                    </template>
                                </template>
                                <span v-else class="text-center">No Vendor Bussiness found</span>
                            </div>
                        </div>


                    </div>


                    <div class="card  create-box-view mb-3">
                        <div class="card-header headnbtn">
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="card-title mb-0 flex-grow-1">About Vendor</h5>
                                <!--<a href="#" class="fs-24" style="line-height: 0" ><i class="bx bxs-plus-circle"></i></a>-->
                                <a class="clp-btn fs-24" href="javascript:void(0)" @click="addAbout"><i class="ri-add-circle-fill" id ="add-about"></i></a>
                            </div>
                        </div>
                        <div class="card-body p-3">
                            <div class="white-bg ">
                                <!--<a class="clp-btn" href="#"><span class="fa fa-plus-circle pull-right" id ="add-about"></span></a>-->
                                <div class="about-vendorAdd">
                                <template v-if="add_vendor">
                                    <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                                        <strong class="success_msg">{{successMessage}}</strong>
                                    </div>
                                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                                        <ul>
                                            <li v-for="(v, k) in commonErrors" :key="k">
                                                <p v-for="error in v" :key="error" class="text-sm">
                                                    {{ error }}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                <div class="row" style="padding:15px;" id="about_vendor_add">
                                    <textarea class="form-control" name="notes" v-model="about_vendor" id="notes" placeholder=""></textarea>
                                    <input type="hidden" name="vendor_id" id="vendor_id" value="1336">
                                    <div class="notes-btns">
                                        <button class="btn btn-blue" @click="addAboutSave" id="add-no">Save</button>
                                        <button type="button" id="close_note" @click="addAboutCancel" class="btn btn-secondary">Cancel</button>
                                    </div>
                                </div>
                                </template>
                                    <template v-if="vendorData.about_vendor">
                                        <template v-for="notes in vendorData.about_vendor">
                                            <div class="task-bg" v-if="notes['description'] != 'undefined' ">
                                                <div class="small-heading" v-html="nlToBr(notes['description'])"></div>
                                                <!-- <div class="d-flex justify-content-between">
                                                    <div class="text-muted">Created By {{notes['added_by']}}</div>
                                                    <div class="text-muted text-italic">{{notes['post_time']}}</div>
                                                </div> -->
                                                <span class="pull-right lght-clr">{{notes['post_time']}}</span>
                                                <div class="row">
                                                    <div class="col-md-8">
                                                        <div class="light-clr">Created By {{notes['added_by']}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </template>


                                    <div class="task-bg" v-if="vendorData.vendor.about_us != 'undefined'">
                                        <div class="small-heading" v-html="nlToBr(vendorData.vendor.about_us)"></div>
                                        <span class="pull-right lght-clr">{{vendorData.post_time}}</span>
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="light-clr">Created By {{vendorData.added_by}}</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="card  create-box-view mb-3">
                        <div class="card-header headnbtn">
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="card-title mb-0 flex-grow-1">Terms</h5>
                            </div>
                        </div>
                        <div class="card-body p-3">
                            <div class="white-bg">
                                <div>{{vendorData.vendor.vendor_terms != 'undefined' ? vendorData.vendor.vendor_terms  : ''}}</div>
                            </div>
                        </div>

                    </div>

                    <div class="card  create-box-view mb-3">
                        <div class="card-header headnbtn">
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="card-title mb-0 flex-grow-1">Found them</h5>
                            </div>
                        </div>
                        <div class="card-body p-3">
                            <div class="white-bg">
                                <div>{{vendorData.vendor.found_them != 'undefined' ? vendorData.vendor.found_them : ''}}</div>
                            </div>
                        </div>

                    </div>

                    <div class="card  create-box-view mb-3">
                        <div class="card-header headnbtn">
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="card-title mb-0 flex-grow-1">Doing Exports?</h5>
                            </div>
                        </div>
                        <div class="card-body p-3">
                            <div class="white-bg">
                                <div>{{vendorData.vendor.doing_exports != 'undefined' ? vendorData.vendor.doing_exports : ''}}</div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <div class="mb-4 row">

        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-header border-0">
                    <div class="d-flex align-items-center">
                        <h5 class="card-title mb-0 flex-grow-1">Purchase Orders</h5>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive product-create table-card">
                        <table class="table table-custom align-middle table-nowrap mb-0">
                            <thead>
                            <tr>
                                <th style="width: 160px">Order #</th>
                                <th>Planned Delivery Date</th>
                                <th>Vendor</th>
                                <th>Amount</th>
                                <th>Added By</th>
                                <th>Created</th>
                                <th>Updated</th>
                                <th>Status</th>
                                <!-- <th style="width: 100px">Action </th> -->
                            </tr>
                            </thead>
                            <template v-if="orderData != null && orderData.data.length > 0">
                                <template v-for="(item, index) in orderData.data">
                                    <tr :id="item.id">
                                        <td>
                                            <router-link :to="{ name: 'purchaseOrderShow', params: { id: item.id }}" class="edit-btn">#{{ item.po_number }}</router-link>
                                        </td>
                                        <td>{{ item.eta }}</td>
                                        <td>
                                            <router-link target="_blank" :to="{ name: 'vendorDetails', params: { id: item.vendor_id }}" class="edit-btn">
                                            {{ item.vendor ? item.vendor.company_name : '' }}
                                            </router-link>
                                        </td>
                                        <td>${{ item.amount }}</td>
                                        <td>{{ item.added_by ? item.added_by.name : '' }}</td>
                                        <td>{{ item.created_at }}</td>
                                        <td>{{ item.updated_at }}</td>
                                        <td><span :class="formatStatusClass(item)">{{ item.purchase_order_status ? item.purchase_order_status.name : "" }}</span></td>

                                        <!-- <td>
                                            <router-link :to="{ name: 'purchaseOrderShow', params: { id: item.id }}" class="edit-btn"><i class="fas fa-pencil-alt" aria-hidden="true"></i></router-link>
                                        </td> -->
                                    </tr>
                                </template>
                            </template>

                        </table>

                        <div class="btnrow text-left" v-if="orderData != null && orderData.data.length">
                            <template>
                                <div class="overflow-auto mb-2">
                                    <b-pagination
                                        v-model="current_page"
                                        :total-rows="total"
                                        :per-page="per_page"
                                    ></b-pagination>
                                </div>
                            </template>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>

        <div class="modal right fade" id="myModal3" tabindex="-1" role="dialog" aria-labelledby="myModalLabel3">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">About Vendor</h4>
                        <span class="fa fa-plus-circle pull-right"></span>
                    </div>
                    <div id="message_area" class="alert alert-success" style="display: none;"></div>

                    <div class="modal-body about-vendorAdd">

                    </div>
                    <!-- modal-content -->
                </div><!-- modal-dialog -->
            </div><!-- Tasks modal -->
        </div>
        <!-- Tasks Modal -->
        <div class="modal right fade" id="myModal1" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="myModalLabel3">History</h4>

                    </div>

                    <div class="modal-body">
                        <div class="history-d">
                            <div class="task-bg">
                                <template v-if="vendor_history.length > 0">
                                <template v-for="(item, index) in vendor_history">
                                <div class="small-heading">Vendor was added by {{item.added_by}}</div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="light-clr">Added Time</div>
                                            <p class="number">{{item.created_at}}</p>
                                        </div>
                                    </div>
                                    </template>
                                </template>
                            </div>

                        </div>

                    </div>
                    <!-- modal-content -->
                </div><!-- modal-dialog -->
            </div><!-- Tasks modal -->
        </div>
        <!--- add task -->
    </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";


export default {
    name: "VendorView",
    created() {
        if(localStorage.getItem('token')){
            console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getVendor();
        this.getCountries();
        this.getVendorProduct();
    },
    data(){
        return {
            vendor_history:[],
            add_vendor:false,
            about_vendor:'',
            orderData: {
                purchases: null,
                config: null,
                data:[]
            },
            selectedFile:null,
            vendorData: {
                vendor: null,
                contacts: [],
                country_data: null,
                vendor_contact: null,
                countries: [],
                can_add_vendor: false,
                can_edit_vendor: false,
                can_delete_vendor: false,
                user_type: null,
                role: null
            },
            current_page: 1,
            per_page:10,
            total:0,
            filterForm: {
                search_filter: null,
                status_filter: '1'
            },
            countries: [],
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading'
        ]),
        previewFiles() {
            this.selectedFile = event.target.files[0];

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            let formData = new FormData();
            formData.append('file', this.selectedFile);
            formData.append('vendor_id', this.$route.params.id);

            return axios.post(window.route('vendor.addAttachment'), formData,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                },
                headers: {
                        'Content-Type': 'multipart/form-data'
                },
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                       // this.vendorData = data.data;
                        console.log(data.message);
                        this.getVendor();


                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });


        },
        openHistory(){


            let self = this;
            this.vendor_history = [];
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendor.getHistory',{vendor_id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.vendor_history = data.data;
                        $('#myModal1').modal('show');
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });



        },
        addAboutSave(){
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('vendor.aboutVendor'),{vendor_id: this.$route.params.id,notes:this.about_vendor}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.add_vendor = false;
                        //this.vendorData = data.data;
                        this.getVendor();
                        this.getCountries();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        addAbout(){
            this.about_vendor = '';
            this.add_vendor = true;
        },
        addAboutCancel(){
            this.about_vendor = '';
            this.add_vendor = false;
        },
        formatStatusClass(item) {
            if(item.purchase_order_status) {
                return item.purchase_order_status.name.replace(/\s+/g, '-').replace("/", "-").toLowerCase();
            }
            return "";
        },
        getVendorProduct() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendors.po.index', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.orderData = data.data.purchases;
                        console.log("purchase order",this.orderData);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getVendor() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendors.show', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.vendorData = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getCountries() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('countries.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.countries = data.data.countries;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        deletFile(filename, id) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('vendor.deleteAttachment', {id: id,file_name:filename}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        //this.vendorData = data.data;
                        console.log(data.data);
                        this.getVendor();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        async downloadItem({ url, label }) {
            // const response = await axios.get(url, { responseType: "blob" });
            // const blob = new Blob([response.data], { type: "application/pdf" });
            // const link = document.createElement("a");
            // link.href = URL.createObjectURL(blob);
            // link.download = label;
            // link.click();
            // URL.revokeObjectURL(link.href);

            axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fullUri = document.createElement('a');

                     fullUri.href = fileURL;
                     fullUri.setAttribute('download', label);
                     document.body.appendChild(fullUri);

                     fullUri.click();
                });

        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
